import { Injectable } from "@angular/core";
import { Customer } from "@app/customer/model/customer";
import { ClareSystem } from "@app/project/model/clare-system";
import { ClareSystemDbService } from "@app/project/services/clare-system-db.service";
import { ProjectDbService } from "@app/project/services/project-db.service";
import { User } from "@app/user/model/user";
import { UserDbService } from "@app/user/service/user-db.service";
import { UserRoleService } from "@app/user/service/user-role.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

// @TODO This should be gone by the time WS security changes are complete (DDB-4819)
const CLARE_SYSTEM_TABLE = "claresystem";

@Injectable({
    providedIn: "root",
})
export class CustomerPortalDbService {
    userClaresystemDbEndpoint = "userinfo_claresystem";

    getUserByEmail(user: User, uuid: string): Observable<{ invitedUser: User }> {
        return this.userDbService.getOrCreateUserByEmail(user, uuid);
    }

    getCustomerRoleId() {
        return this.userRoleService.getUserRoles().pipe(map(roles => this.userRoleService.getCustomerRole(roles).id));
    }

    getLocationUsers(claresystemId: number) {
        return this.userDbService
            .getLocationsBySystemId(claresystemId)
            .pipe(map(users => users.map(user => ({ userinfo: this.userDbService.helper.fromDbObject(user) }))));
    }

    /* eslint-disable @typescript-eslint/naming-convention */
    addUserToLocation(userinfoId: number, claresystemId: number) {
        return this.projectDbService.connectUserToClaresystem(
            {
                id: userinfoId,
            } as Customer,
            {
                id: claresystemId,
            } as ClareSystem
        );
    }
    /* eslint-enable @typescript-eslint/naming-convention */

    removeUserFromLocation(userinfoId: number, claresystemId: number) {
        return this.projectDbService.deleteUserinfoClaresystem(userinfoId, claresystemId);
    }

    /**
     *
     * @param claresystem remove all mobile user
     * @returns Observable
     */
    removeAllMobileUser(claresystemId: number) {
        return this.projectDbService.deleteAllUserInfoBySystem(claresystemId);
    }

    /**
     * Update the ClareSystem object
     *
     * @param claresystem - This object contains other relationships.
     * Only pulling out the updateable values.
     */
    updateLocation(claresystem: ClareSystem) {
        /* eslint-disable @typescript-eslint/naming-convention */
        return this.clareSystemDbService.updateClareSystem(claresystem);
    }

    getLocationsByCustomer(customerId: number) {
        return this.userDbService.getLocationsByCustomer(customerId);
    }

    constructor(
        private readonly userDbService: UserDbService,
        private readonly userRoleService: UserRoleService,
        private readonly projectDbService: ProjectDbService,
        private readonly clareSystemDbService: ClareSystemDbService
    ) {}
}
